import React from 'react';
import { Trash2, Download, ShoppingCart } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { downloadBlob } from './materialUtils';
import { fmt } from '../../../lib/projectVisuals';

const toCSV = (items) => '\uFEFF' + [['Produkt', 'Byggdel', 'Mängd', 'Enhet', 'Á-pris', 'Totalt', 'Leverantör'],
  ...items.map((i) => [i.name, i.phase, i.quantity, i.unit, i.unit_price, i.total, i.supplier])]
  .map((r) => r.map((v) => `"${String(v ?? '').replace(/"/g, '""')}"`).join(';')).join('\n');

export const PurchaseListDialog = ({ open, onOpenChange, items, onRemove, projectName }) => {
  const total = items.reduce((s, i) => s + (Number(i.total) || 0), 0);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="purchase-list-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><ShoppingCart size={18} className="text-[#F26B1F]" />Inköpslista</DialogTitle></DialogHeader>
        {items.length === 0 ? (
          <p className="py-8 text-center text-sm text-stone-500" data-testid="purchase-list-empty">Klicka på en materialrad och välj "Lägg till i inköpslista".</p>
        ) : (
          <>
            <div className="divide-y divide-stone-100">
              {items.map((i) => (
                <div key={i.key} className="flex items-center gap-3 py-2.5" data-testid={`purchase-item-${i.key}`}>
                  <div className="flex-1 min-w-0"><p className="text-sm font-semibold truncate">{i.name}</p><p className="text-xs text-stone-500 truncate">{i.phase} · {i.supplier || 'Leverantör ej angiven'}</p></div>
                  <p className="text-xs text-stone-500 op-num w-24 text-right">{fmt(i.quantity, 1)} {i.unit}</p>
                  <p className="text-sm font-semibold op-num w-28 text-right">{fmt(i.total)} kr</p>
                  <button onClick={() => onRemove(i.key)} className="p-1.5 text-stone-400 hover:text-red-600" data-testid={`purchase-remove-${i.key}`}><Trash2 size={14} /></button>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between border-t-2 border-stone-200 pt-3">
              <p className="text-sm font-bold">Totalt (exkl. moms)</p>
              <p className="text-lg font-bold op-num" data-testid="purchase-list-total">{fmt(total)} kr</p>
            </div>
            <button className="op-btn-primary w-full" data-testid="purchase-list-export"
              onClick={() => downloadBlob(new Blob([toCSV(items)], { type: 'text/csv;charset=utf-8' }), `Inkopslista_${(projectName || 'projekt').replace(/\s+/g, '_')}.csv`)}>
              <Download size={16} />Exportera inköpslista
            </button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
